import { fork } from 'redux-saga/effects';
import { queryData } from 'store/sagas/apiService';
import { LoadOptions, LoadType } from 'store/sagas/apiService/types';


export function* savedSearchesPageHandler() {

  const loadOptions: LoadOptions<LoadType.SavedSearchesNotifications> = {
    loadType: LoadType.SavedSearchesNotifications,
    meta: {
      variables: {},
    },
  };
  yield fork(queryData, loadOptions);
}
